import React      from 'react';
import IconButton from './IconButton';

const ScreenMirroring = () => (
	<IconButton icon={'-icon-smarttv-line'} checkedIcon={'-icon-smarttv-full'} />
);

export default ScreenMirroring;
